import React, { useState, useEffect } from "react";
import { Grid, Box, Typography, Link, Button } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { CustomNumberField, CustomTextField } from "src/components/uiElements";
import { CustomPrimaryButtonFixed } from "src/components/uiElements/buttons/primaryButtonFixed";
import UseSignUp from "src/screens/outerScreens/signup/useSignUp";
import { VerifyOTP } from "src/components/api/user/user";
import SiginInScreen from "../signin/signInScreen";
import ForgotPasswordScreen from "../forgot_password/forgotPasswordScreen";
import CustomCheckBoxNew from "src/components/uiElements/buttons/customCheckBoxNew";
import UseVerifyOtp from "./useVerifyOtp";

const VerifyOtpScreen = ({ mobileNumber, signupData, onOtpSubmit, onBack, onSuccess }: { mobileNumber: string, signupData?: any, onOtpSubmit?: (values: any) => Promise<boolean>, onBack?: () => void, onSuccess?: () => void }) => {
  const {
    loading,
    isSignUpOpen,
    IsSignUp,
    onSubmit,
    isUpdate,
    setIsSignInOpen,
    isSignInOpen,
    isRegiSuccess,
    setIsRegiSuccess,
    setIsSignUp,
    setIsSignUpOpen,
    isOtpScreenOpen,
    setIsOtpScreenOpen,
    formContext,
  } = UseVerifyOtp(mobileNumber, signupData, onSuccess);

  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [FirmName, setFirmName] = useState("");
  const [MobileNumber, setMobileNumber] = useState("");
  const [EmailID, setEmailID] = useState("");
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleButtonClick();
    }
  };

  
 
  const { handleSubmit, getValues } = formContext;

  let values = getValues();

  const handleButtonClick = async () => {
    if (onOtpSubmit) {
      const values = getValues();
      const success = await onOtpSubmit(values);
      if (!success) {
        return;
      }
      return;
    }

    await handleSubmit(onSubmit)();
  };

  const [isTandCChecked, setIsTandCChecked] = useState(false);

  useEffect(() => {
    if (mobileNumber) {
      formContext.setValue('MobileNumber', mobileNumber);
    }
  }, [mobileNumber, formContext]);

  return (
    <>
        <FormProvider {...formContext}>
          <form
            onSubmit={(e) => { e.preventDefault(); handleButtonClick(); }}
            noValidate
            style={{ width: "100%", padding: "30px" }}
          >
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Grid
                item
                xs={3}
                sx={{
                  "@media (max-width: 768px)": {
                    width: "100%",
                  },
                }}
              >
                <Box sx={{ textAlign: "left" }}>
                  <img
                    src="/logo_b.png"
                    width={"170"}
                    style={{ display: "inline" }}
                  />
                </Box>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#000000",
                    textTransform: "titlecase",
                    fontWeight: "700",
                    fontSize: "24px",
                    textAlign: "left",
                    marginTop: "20px",
                    marginBottom: "0px",
                  }}
                >
                  Verify OTP
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: "16px",
                    fontWeight: "300",
                    color: "#000000",
                    textAlign: "left",
                    marginBottom: "20px",
                  }}
                >
                  Enter your valid OTP for {mobileNumber}.
                </Typography>
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      justifyContent: "center",
                    }}
                  >
                    <Grid item xs={12} sx={{ mt: "8px" }}>
                      <CustomTextField
                        fullWidth
                        label={"OTP"}
                        placeholder="OTP"
                        name={"OTP"}
                        type={"OTP"}
                        size="small"
                      />
                    </Grid>

                    {onBack && (
                      <Grid item xs={12} sx={{ textAlign: "left", mt: "10px" }}>
                        <Link
                          onClick={onBack}
                          sx={{
                            textDecoration: "none",
                            fontSize: "14px",
                            color: "#6A0DAD",
                            fontWeight: 300,
                            cursor: "pointer",
                            "&:hover": {
                              color: "#000000",
                            },
                          }}
                        >
                          <span style={{ textDecoration: "underline" }}>Back</span>
                        </Link>
                      </Grid>
                    )}

                    <Grid
                      item
                      xs={12}
                      style={{
                        alignItems: "center",
                        display: "grid",
                      }}
                      sx={{ mt: "14px" }}
                    >
                      <CustomPrimaryButtonFixed
                        style={{
                          fontSize: "20px",
                          fontWeight: 500,
                          justifySelf: "center",
                          width: "100%",
                        }}
                        // onClick={
                        //   IsSignUp ? handleSignUpOpen : handleButtonClick
                        // }
                        title="Verify"
                        loading={loading}
                      />
                    </Grid>
                  </Grid>
              </Grid>
            </Grid>
          </form>
        </FormProvider>      

    </>
  );
};
export default VerifyOtpScreen;
